import { render, staticRenderFns } from "./UIInput.vue?vue&type=template&id=0601e6b6&scoped=true&"
import script from "./UIInput.vue?vue&type=script&lang=js&"
export * from "./UIInput.vue?vue&type=script&lang=js&"
import style0 from "./UIInput.vue?vue&type=style&index=0&id=0601e6b6&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601e6b6",
  null
  
)

export default component.exports